"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function PersonligKontakt() {
  return <section id="personlig-kontakt" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Image Column */}
          <div className="relative">
            <div className="aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-xl">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/project_manager_portrait_office.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626429/img/project_manager_portrait_office.png-wvc-sizes" alt="Projektledare på Proffsbadrum" className="w-full h-full object-cover" loading="eager" fetchpriority="high" src="https://proffsbadrum.se/wp-content/uploads/2026/09/Kontakta-oss.webp" />
            </div>
            
            {/* Contact Card Badge */}
            <div className="absolute bottom-6 left-6 right-6 sm:bottom-8 sm:left-8 sm:right-8 bg-background/95 backdrop-blur-md p-6 rounded-xl shadow-lg border border-border">
               <p className="font-default font-semibold text-foreground text-xl mb-1">
                 Anna Svensson
               </p>
               <p className="text-muted-foreground text-sm font-medium">
                 Projektledare & Badrumsdesigner
               </p>
            </div>
          </div>

          {/* Content Column */}
          <div className="flex flex-col gap-10">
            <div className="max-w-xl">
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
                Personlig service för ditt drömbadrum
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Har du frågor om din kommande badrumsrenovering eller vill du boka ett förutsättningslöst rådgivningsmöte? Tveka inte att höra av dig. Vi finns här för att guida dig från första idé till färdigt, exklusivt badrum.
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {/* Phone Arvika */}
              <Link to="tel:+4657080803" className="group flex items-center gap-6 p-4 -ml-4 rounded-xl hover:bg-muted/50 transition-colors duration-300">
                <div className="flex items-center justify-center w-16 h-16 shrink-0 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <Phone className="w-7 h-7" />
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground mb-1 uppercase tracking-wider">
                    Ring Arvika direkt
                  </p>
                  <p className="font-default text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                    0570-808 03
                  </p>
                </div>
              </Link>

              {/* Phone Karlstad */}
              <Link to="tel:+46548070780" className="group flex items-center gap-6 p-4 -ml-4 rounded-xl hover:bg-muted/50 transition-colors duration-300">
                <div className="flex items-center justify-center w-16 h-16 shrink-0 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <Phone className="w-7 h-7" />
                </div>
                <div>
                  <p className="text-sm font-medium text-muted-foreground mb-1 uppercase tracking-wider">
                    Ring Karlstad direkt
                  </p>
                  <p className="font-default text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                    054-80 70 80
                  </p>
                </div>
              </Link>

              {/* Email */}
              <Link to="mailto:info@proffsbadrum.se" className="group flex items-center gap-6 p-4 -ml-4 rounded-xl hover:bg-muted/50 transition-colors duration-300">
                <div className="flex items-center justify-center w-16 h-16 shrink-0 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <Mail className="w-7 h-7" />
                </div>
                <div className="break-all">
                  <p className="text-sm font-medium text-muted-foreground mb-1 uppercase tracking-wider">
                    Skicka ett mejl
                  </p>
                  <p className="font-default text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                    info@proffsbadrum.se
                  </p>
                </div>
              </Link>
            </div>

            {/* Service Area */}
            <div className="flex items-center gap-3 pt-6 mt-2 border-t border-border/50 text-muted-foreground">
               <MapPin className="w-5 h-5 shrink-0" />
               <span className="text-base font-medium">Vi är verksamma i hela Värmland, Sverige</span>
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}